// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import integration from '@segment/analytics.js-integration';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { flatten } from 'flat';
import generate from 'global-queue';
import isEqual from 'lodash/isEqual';

import perspectiveTracking from './perspective-tracking-api';
import events from '../tracking/events';

const push = generate('ps_dataLayer', { wrap: false });

/**
 * Expose `PS_TRACKING`
 * @type {Integration}
 * @api public
 * @description
 * This is the main integration file for Perspective Tracking.
 * It is responsible for initializing the Perspective Tracking API and
 * pushing the dataLayer to the window object.
 */

// Disclaimer: `functions` are used over arrow functions to preserve the `this` context.

const PS_TRACKING = integration('Perspective').global('ps_dataLayer').readyOnInitialize();

PS_TRACKING.prototype.initialize = function () {
    this.ready();
};

PS_TRACKING.prototype.page = function (page: {
    properties: {
        (): {
            pageId: string;
            pageName: string;
            pageSlug: string;
            isLastPage: boolean;
        };
    };
    obj: {
        name: string;
        event: any;
        properties: any;
    };
}) {
    page.obj.event = events.pageLoad;
    const { pageId, pageName, pageSlug, isLastPage } = page.properties();
    page.obj.properties = {
        pageId,
        pageName,
        pageSlug,
        isLastPage,
    };
    perspectiveTracking.page(page.obj);
    push({
        ...page.obj,
        event: page.obj.name,
    });
};

let lastIdentifyData = {};
PS_TRACKING.prototype.identify = function (identify: { obj: any }) {
    const data = {
        ...identify.obj,
        traits: flatten(identify.obj.traits),
    };

    if (isEqual(data, lastIdentifyData)) {
        return;
    }

    perspectiveTracking.identify(data);
    lastIdentifyData = data;
};

PS_TRACKING.prototype.track = function (track: { obj: any }) {
    perspectiveTracking.track(track.obj);
    push(track.obj);
};

export default PS_TRACKING;
